<template>
    <nio-optional class="space-y-1" :value="formattedPhones">
        <div
            :class="phone.className"
            :key="phone.id"
            v-tooltip="phone.tooltip"
            v-for="phone in formattedPhones"
        >
            {{ phone.number }}
        </div>
    </nio-optional>
</template>

<script>
    export default {
        props: {
            contact: {
                type: Object,
                required: true,
            },
            contactPhoneId: {
                type: Number,
                default: null,
            },
        },

        computed: {
            phones() {
                return this.contact.phones || [];
            },

            filteredPhones() {
                if (this.contactPhoneId) {
                    return this.phones.filter(p => p.id === this.contactPhoneId);
                }

                return this.phones.filter(p => !!p.number);
            },

            formattedPhones() {
                const getClassName = phone => {
                    if (!this.phoneIsValid(phone)) {
                        return 'border-dashed border-b border-gray-400 line-through';
                    }

                    if (!phone.validated) {
                        return 'border-dashed border-b border-gray-400 italic';
                    }

                    return '';
                };

                const getTooltip = phone => {
                    if (!this.phoneIsValid(phone)) {
                        return this.$t('contacts.phones.invalid');
                    }

                    if (!phone.validated) {
                        return this.$t('contacts.phones.notValidated');
                    }

                    return '';
                };

                return this.filteredPhones.map(phone => ({
                    id: phone.id,
                    number: this.formatPhone(phone.number),
                    tooltip: getTooltip(phone),
                    className: getClassName(phone),
                }));
            },
        },
    };
</script>
